export const Links = {
  User: {
    appStore:
      "https://apps.apple.com/us/app/lodapoint-ride-move-goods/id6473742041",
    playStore:
      "https://play.google.com/store/apps/details?id=com.loda.technologies.com&hl=en_US",
  },
  Driver: {
    appStore: "https://apps.apple.com/us/app/lodapoint-driver/id6473671893",
    playStore:
      "https://play.google.com/store/apps/details?id=com.loda.lodadriver&hl=en_US",
  },
  Transporter: {
    appStore:
      "https://apps.apple.com/us/app/lodapoint-transporter/id6483808446",
    playStore:
      "https://play.google.com/store/apps/details?id=com.loda.transporter&hl=en_US",
  },
};




